export function inlineSqlReferences(markdown: string): string {
  return markdown.replace(
    /(^|:[ \t]*\r?\n(?:[ \t]*\r?\n)*|\n) {0,3}(`{3,}|~{3,})[ \t]*(?:sql|bigquery|bq)[ \t]*\r?\n([\s\S]*?)\r?\n {0,3}\2[ \t]*(?=\r?$|\r?\n)/gim,
    (match, prefix: string, fence: string, body: string) => {
      const reference = body.trim().replace(/^`([^`]+)`$/, '$1');
      if (!/^[a-z_][\w-]*(?:\.[a-z_][\w-]*)+$/i.test(reference)) {
        return match;
      }

      return `${prefix.startsWith(':') ? ': ' : prefix}\`${reference}\``;
    },
  );
}
